import { render, staticRenderFns } from "./ShortlinkSettings.vue?vue&type=template&id=77e59ea4&scoped=true&"
import script from "./ShortlinkSettings.vue?vue&type=script&lang=js&"
export * from "./ShortlinkSettings.vue?vue&type=script&lang=js&"
import style0 from "./ShortlinkSettings.vue?vue&type=style&index=0&id=77e59ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e59ea4",
  null
  
)

export default component.exports